import {ButtonPrimary, IconChevronRight20, ToggleSwitch} from "pac-ux-components";
import React, {useEffect, useState} from "react";
import Add24 from "pac-ux-components/build/Icons/Navigation/Add24";
import AddStoreModal from "./AddStoreModal";
import EditStoreModal from "./EditStoreModal";
import { disableStore, enableStore, toggleUmb } from './StoreActions';
import {useCookies} from "react-cookie";

function StoresList(props) {
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [loading, setLoading] = useState(true);
    const [addingStore, setAddingStore] = useState(false);
    const [editingStore, setEditingStore] = useState(null);
    const [error, setError] = useState(null);
    const [merchants, setMerchants] = useState({});
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json', 'Authorization': 'Bearer ' + cookies.idToken
    }

    useEffect(() => {
        fetchMerchants().then(setLoading(false));
    }, [apiRoot, props.stores]);

    const handleEnableStore = (store) => enableStore(apiRoot, cookies.idToken, props.tenant.id, store, props.setStores, setError);
    const handleDisableStore = (id) => disableStore(apiRoot, cookies.idToken, props.tenant.id, id, props.setStores, setError);
    const handleToggleUmb = (store) => {
        toggleUmb(apiRoot, cookies.idToken, props.tenant.id, store, props.setStores, setError);
    };

    async function fetchMerchants() {
        try {
            const updatedMerchants = {};

            for (const store of props.stores) {
                const response = await fetch(apiRoot + '/backoffice/tenants/' + props.tenant.id + '/stores/' + store.id + '/merchant-profiles', {headers: apiHeaders});
                const merchantsData = await response.json();
                updatedMerchants[store.id] = merchantsData.content.length;
            }
            setMerchants(updatedMerchants);
        } catch (error) {
            console.error("Error fetching merchants:", error);
        }
    }

    async function handleSave(store, method = 'PUT') {
        setLoading(true);
        try {
            let url = apiRoot + '/backoffice/tenants/' + props.tenant.id + '/stores';
            if (method === 'PUT') {
                url += '/' + store.id;
            }
            if (method === 'POST') {
                store.enabled = true;
                store.test = false;
                store.isUmbEnabled = false;
            }
            const response = await fetch(url, {
                method: method, headers: apiHeaders, body: JSON.stringify(store),
            });

            if (!response.ok) {
                throw new Error('Failed to save store');
            }


        } catch (error) {
            console.error('Error saving store:', error);
            setError('Failed to save store.');
        } finally {
            setAddingStore(false);
            setEditingStore(false);
            await props.getStores();
        }
    }

    if (loading) return (<div>Loading...</div>);
    if (error) return <p>Error: {error}</p>;

    return (<div>
        <div style={{float: 'right', marginBottom: 8}}>
            <ButtonPrimary
                onClick={() => {
                    setAddingStore(true);
                }}
            ><Add24/> Add Store </ButtonPrimary>
        </div>

        {props.stores.length > 0 && (

            <table width="1047px" className="Table" style={{}}>
                <thead>
                <tr style={{
                    fontWeight: 600, height: 48, fontSize: 16, fontFamily: 'Inter', border: "thin solid #E0E0E0"
                }}>
                    <td width="520" style={{paddingLeft: 32}}>Store</td>
                    <td width="200">Merchant Profiles</td>
                    <td>Enable UMB</td>
                    <td>Enable</td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {props.stores.map((store, index) => (<tr key={store.id} style={{
                    height: 48,
                    fontSize: 16,
                    fontWeight: 400,
                    backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                    border: "thin solid #E0E0E0"
                }}>
                    <td style={{paddingLeft: 32, cursor: 'pointer'}}
                        onClick={() => (setEditingStore(store))}
                    >
                        {store.name}
                    </td>
                    <td>
                        {merchants[store.id]}
                    </td>
                    <td>
                        <ToggleSwitch
                            checked={store.isUmbEnabled}
                            style={{width: 180}}
                            onClick={() => handleToggleUmb(store)}
                        >
                            {store.isUmbEnabled ? 'On' : 'Off'}
                        </ToggleSwitch>
                    </td>
                    <td>
                        <ToggleSwitch
                            checked={store.enabled}
                            style={{width: 180}}
                            onClick={() => store.enabled ? handleDisableStore(store.id) : handleEnableStore(store)}
                        >{store.enabled ? 'On' : 'Off'}</ToggleSwitch>
                    </td>
                    <td>
                        <a href={'/tenants/' + props.tenant.id + '/stores/' + store.id}>
                            <IconChevronRight20
                                style={{color: 'black', marginRight: 8}}
                            />
                        </a>
                    </td>
                </tr>))}
                </tbody>
            </table>)}

        {addingStore && (<AddStoreModal tenant={props.tenant} display={true} handleSave={handleSave} closeModal={() => {
            setAddingStore(false)
        }}/>)}

        {editingStore && (
            <EditStoreModal store={editingStore} display={true} handleSave={handleSave} closeModal={() => {
                setEditingStore(null);
            }}/>)}
    </div>);
}

export default StoresList;
